function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSurveyRexFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M26 5h-3v5H9V5H6c-1.1 0-2 .9-2 2v21c0 1.1.9 2 2 2h20c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm-4 19H10v-2h12v2zm0-4H10v-2h12v2zm0-4H10v-2h12v2z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 8h10V4c0-1.1-.9-2-2-2h-6c-1.1 0-2 .9-2 2v4z",
    fill: props.color
  }));
}

export default SvgIconSurveyRexFilled;